import React from "react";
import { ImageTextPair } from "../image-text-pair";
import style from "./style.module.css";

export interface IMethodDescriptor {
    title: string;
    body: string;
    imgSrc: string;
    altText?: string;
}

export interface IMethodOverviewProps {
    title?: string;
    methods: IMethodDescriptor[];
}

export function MethodOverview(props: IMethodOverviewProps) {
    return (
        <section className={style.methodOverview}>
            {props.title ? <h3 className={style.groupTitle}>{props.title}</h3> : null}
            {
                props.methods.map((method: IMethodDescriptor, index: number) => {
                    return <ImageTextPair
                        key={method.title}
                        imgSrc={method.imgSrc}
                        altText={method.altText}
                        title={method.title}
                        body={method.body}
                        goofy={index % 2 === 1}
                    />;
                })
            }
        </section>
    );
}